// extracted by mini-css-extract-plugin
module.exports = {"columns":"Main_columns__2xpry","column":"Main_column__22gar","createButton":"Main_createButton__2l9iq","img1":"Main_img1__30-wD","img2":"Main_img2__2osQG"};